import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select';

export default class extends Controller {
  static values = {
    maxItems: Number,
  }

  connect () {
    var options = {
      create: false,
      closeAfterSelect: true,
      plugins: {
        remove_button: {},
        clear_button: {},
      }
    }

    if(this.hasMaxItemsValue) options.maxItems = this.maxItemsValue;

    if(this.element.list) {
      options.options = Array.from(this.element.list.querySelectorAll("option"))
        .map(e => { return { value: e.value, text: e.value} })
    }

    this.selector = new TomSelect(this.element, options)
  }

  disconnect () {
    this.selector.destroy()
  }
}
